/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export const admin = [
  {
    url: '/admin/dashboard',
    name: 'Dashboard',
    slug: 'dashboard',
    icon: 'HomeIcon'
  },
  {
    url: '/admin/events',
    name: 'Events',
    slug: 'events',
    icon: 'UmbrellaIcon'
  },
  {
    url: '/admin/service-request',
    name: 'Service Requests',
    slug: 'serviceRequest',
    icon: 'FileIcon'
  },
  {
    url: '/admin/users/vendor',
    name: 'Vendors',
    slug: 'admin-user-vendor',
    icon: 'PackageIcon'
  },
  {
    url: '/admin/users/bride',
    name: 'Brides',
    slug: 'admin-user-bride',
    icon: 'UserIcon'
  },
  {
    url: '/admin/users/unassigned',
    name: 'Unassigned',
    slug: 'admin-user-unassigned',
    icon: 'UserXIcon'
  },
  {
    url: '/admin/transactions',
    name: 'Transactions',
    slug: 'transactions',
    icon: 'DollarSignIcon'
  },
  {
    url: '/admin/counties',
    name: 'Counties',
    slug: 'admin-counties',
    icon: 'MapIcon'
  },
  {
    url: '/admin/blog',
    name: 'Blog',
    slug: 'blog',
    icon: 'BookIcon'
  },
  {
    url: null,
    name: 'Users',
    icon: 'UsersIcon',
    i18n: 'User',
    submenu: [
      {
        url: '/admin/users/partner',
        name: 'Partners',
        slug: 'admin-user-partner'
      },
      {
        url: '/admin/users/promoter',
        name: 'Promoters',
        slug: 'admin-user-promoter'
      },
      {
        url: '/admin/users/support',
        name: 'Associates',
        slug: 'admin-user-support'
      },
      {
        url: '/admin/users/admin',
        name: 'Admins',
        slug: 'user-admin'
      }
    ]
  },
  {
    url: null,
    name: 'Settings',
    icon: 'SettingsIcon',
    submenu: [
      {
        url: '/admin/settings/fees',
        name: 'Fees',
        slug: 'admin-settings-fees'
      },
      {
        url: '/admin/settings/categories',
        name: 'Category',
        slug: 'admin-settings-categories'
      }
    ]
  }
]

export const promoter = [
  {
    url: '/promoter/dashboard',
    name: 'Dashboard',
    slug: 'dashboard',
    icon: 'HomeIcon'
  },
  {
    url: '/promoter/service-request',
    name: 'Service Requests',
    slug: 'serviceRequest',
    icon: 'FileIcon'
  },
  {
    url: '/promoter/counties',
    name: 'Counties',
    slug: 'promoter-counties',
    icon: 'MapIcon'
  },
  {
    url: '/promoter/users/bride',
    name: 'Registered couples',
    slug: 'promoter-user-bride',
    icon: 'UserIcon'
  },
  {
    url: '/promoter/users/vendor',
    name: 'Vendors',
    slug: 'promoter-user-vendor',
    icon: 'PackageIcon'
  },
  {
    url: '/promoter/quote-payments',
    name: 'Quote Payments',
    slug: 'promoter-quote-payments',
    icon: 'DollarSignIcon'
  }
]

export const partner = [
  {
    url: '/partner/dashboard',
    name: 'Dashboard',
    slug: 'dashboard',
    icon: 'HomeIcon'
  }
]

export const support = [
  {
    url: '/associate/dashboard',
    name: 'Dashboard',
    slug: 'dashboard',
    icon: 'HomeIcon'
  },
  {
    url: '/associate/events',
    name: 'Events',
    slug: 'events',
    icon: 'UmbrellaIcon'
  },
  {
    url: '/associate/service-request',
    name: 'Service Requests',
    slug: 'serviceRequest',
    icon: 'FileIcon'
  },
  {
    url: '/associate/users/vendor',
    name: 'Vendors',
    slug: 'admin-user-vendor',
    icon: 'PackageIcon'
  },
  {
    url: '/associate/users/bride',
    name: 'Brides',
    slug: 'admin-user-bride',
    icon: 'UserIcon'
  },
  {
    url: '/associate/transactions',
    name: 'Transactions',
    slug: 'transactions',
    icon: 'DollarSignIcon'
  },
  {
    url: '/associate/blog',
    name: 'Blog',
    slug: 'blog',
    icon: 'BookIcon'
  }
]
